import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, CheckCircle2Icon, GiftIcon } from 'lucide-react';
import { PreviewCarousel } from './PreviewCarousel';
import { bonuses, volumes } from '../data/offer';
import type { Volume } from '../types/content';
const accentStyles: Record<Volume['accent'], {
  border: string;
  text: string;
}> = {
  info: {
    border: 'border-info/30',
    text: 'text-info'
  },
  primary: {
    border: 'border-primary-soft/30',
    text: 'text-primary-soft'
  },
  highlight: {
    border: 'border-highlight/30',
    text: 'text-highlight'
  },
  danger: {
    border: 'border-danger-soft/30',
    text: 'text-danger-soft'
  }
};
export function ProductOffer() {
  return <>
      <section className="bg-surface px-4 py-16 sm:py-24" data-id="element-149" data-mp="uh7a9gd2bhjy">
        <div className="mx-auto max-w-5xl" data-id="element-150" data-mp="fjevwrj94z7c">
          <header className="text-center" data-id="element-151" data-mp="fkg6yw09plp2">
            <h2 className="font-display text-3xl font-bold text-highlight sm:text-5xl" data-id="element-152" data-mp="ki8akna9yw93">
              🏆 PACK COMIDAS RESUELTAS™
            </h2>
            <p className="mx-auto mt-4 max-w-4xl text-lg font-medium" data-id="element-153" data-mp="3le02tgottwlc">
              Tu sistema en 4 volúmenes para planificar, cocinar por tandas y tener tus comidas listas toda la semana.
            </p>
          </header>
          
          <h3 className="mt-12 text-center font-display text-2xl font-bold" data-id="element-154" data-mp="3udn7cbcuriim">
            📚 4 VOLÚMENES COMPLETOS
          </h3>
          <div className="mt-7 space-y-5" data-id="element-155" data-mp="32obpt2kxl0u9">
            {volumes.map((volume, index) => {
            const accent = accentStyles[volume.accent];
            return <motion.article key={volume.title} initial={{
              opacity: 0,
              y: 16
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: index * 0.06
            }} className={`flex gap-5 rounded-2xl border ${accent.border} bg-canvas p-5 sm:p-7`} data-id="element-156" data-mp="2xr1q8u3tv8sp" data-mpi={index}>
                  <BookOpenIcon className={`mt-1 h-7 w-7 shrink-0 ${accent.text}`} aria-hidden="true" data-id="element-157" data-mp="2eyhdcm4ixeaj" />
                  <div className="flex-1" data-id="element-158" data-mp="hy352uug03bt">
                    <p className={`text-xs font-bold tracking-brand ${accent.text}`} data-id="element-159" data-mp="mx6c2ktzgjmf">
                      {volume.label}
                    </p>
                    <h4 className="mt-1 font-display text-lg font-bold sm:text-xl" data-id="element-160" data-mp="roob33cg4a4r">
                      {volume.title}
                    </h4>
                    <p className="mt-1 text-sm text-foreground-subtle sm:text-base" data-id="element-161" data-mp="3v54u83ia4w4z">
                      {volume.subtitle}
                    </p>
                    <ul className="mt-4 space-y-2" data-id="element-162" data-mp="3z3rci8gx8uf">
                      {volume.items.map(item => <li key={item} className="flex gap-2 text-sm leading-relaxed text-foreground-muted sm:text-base" data-id="element-163" data-mp="8wn4fetfjfks">
                          <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-primary-soft" aria-hidden="true" data-id="element-164" data-mp="dycht144k5c1" />
                          {item}
                        </li>)}
                    </ul>
                    <p className="mt-5 border-t border-foreground/10 pt-4 text-sm sm:text-base" data-id="element-165" data-mp="1pa3jp1b8q2qb">
                      <span className="font-semibold text-foreground-subtle" data-id="element-166" data-mp="39t5yg4qc1qia">Resultado: </span>
                      <span className={`font-bold italic ${accent.text}`} data-id="element-167" data-mp="34ve6xbtlo6em">{volume.result}</span>
                    </p>
                  </div>
                </motion.article>;
          })}
          </div>
        </div>
      </section>
      <PreviewCarousel data-id="element-168" data-mp="2v38fc379fqzy" />
      <section className="bg-canvas px-4 py-16 sm:py-24" data-id="element-169" data-mp="2q6hpio5nlh1c">
        <div className="mx-auto max-w-5xl" data-id="element-170" data-mp="2q3viqqql75k6">
          <header className="text-center" data-id="element-171" data-mp="2m3v5h9f850ep">
            <GiftIcon className="mx-auto h-10 w-10 text-highlight" aria-hidden="true" data-id="element-172" data-mp="2m338bu5zaumb" />
            <h2 className="mt-3 font-display text-3xl font-bold text-highlight sm:text-5xl" data-id="element-173" data-mp="2h5tn6qpmh54a">
              Y ADEMÁS, TE LLEVÁS 5 BONOS
            </h2>
          </header>
          <div className="mt-10 space-y-4" data-id="element-174" data-mp="fe6rwcyp6o20">
            {bonuses.map(({
            number,
            title,
            detail,
            items,
            value
          }) => <article key={number} className="flex flex-col gap-4 rounded-2xl border border-highlight/20 bg-surface p-5 sm:flex-row sm:items-start sm:p-7" data-id="element-175" data-mp="346tt2623jpew">
                <span className="w-fit whitespace-nowrap rounded-lg bg-highlight/10 px-3 py-2 font-bold text-highlight" data-id="element-176" data-mp="387vlo41id37w">
                  🎁 BONO {number}
                </span>
                <div className="flex-1" data-id="element-177" data-mp="2z6o08mk3bwv8">
                  <h3 className="font-bold" data-id="element-178" data-mp="2z9tltrtiggm7">{title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-foreground-muted" data-id="element-179" data-mp="2khrskqly4lv5">
                    {detail}
                  </p>
                  <ul className="mt-3 space-y-1.5" data-id="element-180" data-mp="2pbnnfk6wxsm3">
                    {items.map(item => <li key={item} className="flex gap-2 text-sm leading-relaxed text-foreground-muted" data-id="element-181" data-mp="2bjfs7wva29pi">
                        <CheckCircle2Icon className="mt-0.5 h-4 w-4 shrink-0 text-highlight" aria-hidden="true" data-id="element-182" data-mp="2ghr2g8phim89" />
                        {item}
                      </li>)}
                  </ul>
                </div>
                <div className="flex shrink-0 items-center gap-3" data-id="element-183" data-mp="26ia3ea4qn6l9">
                  <span className="text-xs font-semibold text-foreground-faint" data-id="element-184" data-mp="1myb7g8oojhhj">VALOR:</span>
                  <span className="text-sm text-foreground-faint line-through" data-id="element-185" data-mp="1iwpwwtzmbfai">
                    {value}
                  </span>
                  <span className="rounded-full bg-primary-soft px-3 py-1 text-sm font-bold text-canvas" data-id="element-186" data-mp="1wwqxe8bz0kpg">
                    GRATIS
                  </span>
                </div>
              </article>)}
          </div>
          <div className="mt-8 rounded-2xl border border-highlight/30 bg-highlight/10 p-6 text-center" data-id="element-187" data-mp="25trhw3vx5ynm">
            <p className="text-xs font-bold tracking-brand text-highlight" data-id="element-188" data-mp="2flxj84829sfh">
              VALOR TOTAL BONOS
            </p>
            <p className="mt-1 text-2xl font-bold text-foreground-subtle line-through" data-id="element-189" data-mp="2amc9cyrcrznz">
              $52.000
            </p>
            <p className="mt-2 font-display text-xl font-bold text-highlight" data-id="element-190" data-mp="2pkwhcsv7a5o8">
              GRATIS con tu Pack Comidas Resueltas™
            </p>
          </div>
        </div>
      </section>
    </>;
}